export const REFERENCE_NUMBER_MASTER_LIST_LIMIT = 100;
